module.exports = __webpack_public_path__ + "static/icon-kefu.99983cbf.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon-kefu.png
// module id = 313
// module chunks = 2